module.exports = __webpack_public_path__ + "static/media/giftingIcon.746f24e1.png";